import apiClient from './client';

export const reviewAPI = {
  // Submit a review
  submit: (data) => apiClient.post('/reviews', data),

  // Get review by ID
  getById: (id) => apiClient.get(`/reviews/${id}`),

  // Get my reviews
  getMyReviews: (params = {}) => apiClient.get('/reviews/my-reviews', { params }),

  // Get business reviews
  getBusinessReviews: (businessId, params = {}) => apiClient.get(`/reviews/business/${businessId}`, { params }),

  // Get business rating stats
  getBusinessStats: (businessId) => apiClient.get(`/reviews/stats/business/${businessId}`),

  // Update a review
  update: (id, data) => apiClient.put(`/reviews/${id}`, data),

  // Delete a review
  delete: (id) => apiClient.delete(`/reviews/${id}`),
};